import { Skeleton } from '@/components/ui/skeleton';
import { PageHeaderSkeleton } from './PageHeaderSkeleton';
import { PageWrapper } from '@/components/layout';

/**
 * Skeleton for the Calendar page.
 */
export function CalendarPageSkeleton() {
  return (
    <PageWrapper header={<PageHeaderSkeleton variant="gradient" showDescription={true} />}>
      <div className="space-y-6 mb-12">
        {/* Year Selector */}
        <div className="bg-card border border-border rounded-lg shadow-sm p-4">
          <div className="flex items-center justify-between">
            <Skeleton className="h-5 w-32" />
            <Skeleton className="h-9 w-[180px]" />
          </div>
        </div>

        {/* Calendar Controls */}
        <div className="bg-card border border-border rounded-lg shadow-sm p-4">
          <div className="flex items-center justify-between mb-4">
            <div className="flex items-center gap-2">
              <Skeleton className="h-9 w-9" />
              <Skeleton className="h-6 w-32" />
              <Skeleton className="h-9 w-9" />
            </div>
            <div className="flex gap-2">
              <Skeleton className="h-9 w-20" />
              <Skeleton className="h-9 w-20" />
            </div>
          </div>

          {/* Calendar Grid Header */}
          <div className="grid grid-cols-7 gap-1 mb-2">
            {['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'].map((day) => (
              <Skeleton key={day} className="h-8 w-full" />
            ))}
          </div>

          {/* Calendar Grid */}
          <div className="grid grid-cols-7 gap-1">
            {Array.from({ length: 35 }).map((_, i) => (
              <div key={i} className="aspect-square p-1">
                <Skeleton className="h-full w-full" />
              </div>
            ))}
          </div>
        </div>

        {/* Events List */}
        <div className="bg-card border border-border rounded-lg shadow-sm p-4 space-y-3">
          <Skeleton className="h-5 w-32" />
          {Array.from({ length: 3 }).map((_, i) => (
            <div key={i} className="flex items-start gap-3 p-3 border border-border rounded-lg">
              <Skeleton className="h-10 w-10 rounded flex-shrink-0" />
              <div className="flex-1">
                <Skeleton className="h-5 w-48 mb-1" />
                <Skeleton className="h-4 w-32" />
              </div>
            </div>
          ))}
        </div>
      </div>
    </PageWrapper>
  );
}
